import * as _ from 'lodash';
import { IEwtSummary, ITargetItem } from '@nkr/models/index';
import { useState } from 'react';
import { Button, Panel } from 'react-bootstrap';
import { ListType } from '@nkr/views/target-new/list-type';
import PatientGrid from '@nkr/views/target-new/patient-grid';

interface IProps {
    list: ITargetItem[],
    type: ListType,
    onShowEwt: (ewtSummary: IEwtSummary, initialCount: any) => void,
    onShowMortalityBreakdown: (type: number, recipient: ITargetItem) => void
}

const Targets = (props: IProps) => {
    const [expanded, setExpanded] = useState(false);

    const list = props.type == ListType.HardToMatch
        ? _.orderBy(props.list, [
            item => item.isMatchable ? 0 : 1,
            item => item.potentialDonors.length > 0 && item.potentialDonors.filter(x => x.donorInMatch).length == item.potentialDonors.length ? 0 : 1,
            item => item.sortOrder,
            item => item.recipientAlias
        ])
        : _.orderBy(props.list, [
            item => item.isMatchable ? 0 : 1,
            item => item.sortOrder,
            item => item.recipientAlias
        ]);

    return (
        <Panel style={{ marginBottom: 0 }} expanded={expanded}>
            <Panel.Heading>
                <Button bsSize='sm' onClick={() => setExpanded(!expanded)}>Targets ({props.list.length})</Button>
            </Panel.Heading>

            <Panel.Collapse>
                <Panel.Body>
                    <PatientGrid
                        list={list}
                        type={props.type}
                        fullSize={true}
                        forceAutoHeight={true}
                        showTargetColumn={false}
                        showEwtModel={true}
                        showFwtModel={false}
                        suppressed={false}
                        useRowClass={true}
                        isHighDeclines={false}
                        hidePotentialDonors={true}
                        onGridReady={() => { }}
                        onShowEwt={props.onShowEwt}
                        onShowFwt={() => { }}
                        onShowMortalityBreakdown={props.onShowMortalityBreakdown}
                    />
                </Panel.Body>
            </Panel.Collapse>
        </Panel>
    );
}

export default Targets;
